import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// import SCSS theme
import "./assets/scss/themes.scss";

// import Routes
import Route from "./Routes";

// init auth hook
// import { useInitAuth } from "Components/Hooks/useInitAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logoutUserSuccess } from "slices/auth/login/reducer";
// import { useInitClient } from "Components/Hooks/useInitClient";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "logout") {
        sessionStorage.removeItem("authUser");
        sessionStorage.removeItem("isLoggedIn");
        dispatch(logoutUserSuccess());
        navigate("/login");
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [dispatch, navigate]);

  // useInitClient()
  // const { hydrated } = useInitAuth();


  // if (!hydrated) {
  //   return null; // ✅ avoid layout flicker on page refresh
  // }

  return (
    <React.Fragment>
      <Route />
      
      {/* Global ToastContainer for entire application */}
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        // newestOnTop={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={true}
        theme="light"
        limit={5}
      />
    </React.Fragment>
  );
}

export default App;
